import styled from 'styled-components';

import { CardSection } from 'components/Shared/Cards';
import { SCAFFOLDING } from 'theme';

const CardToolbar = styled(CardSection)`
    padding: 0 ${SCAFFOLDING.GUTTER_FACTOR(0.25)};

    &:after {
        content: '';
        display: table;
        clear: both;
    }
`;

export default CardToolbar;
